import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import "./chatModals.scss";
import CLoseImg from "../../../assets/images/closeIconModal.svg";
import wheelBoy from "../../../assets/images/wheelBoy.png";
import { useState } from "react";

const ChatModal = ({ show, onCloseClick, orderData, handleSendOrder }:any) => {
  const [activeTab, setActiveTab] = useState("customer");

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true} className="smallOrderModal">
      <img
        data-testing-id="closeIcon"
        onClick={onCloseClick}
        className="closeIconModal"
        src={CLoseImg}
        alt="close"
      />
      <ModalBody className="chatOrderBody" style={{height:"500px"}}>
        {/* <div className="tab-bar historyOrder">
          <div
            className={`tab ${activeTab === "customer" ? "active" : ""}`}
            onClick={() => setActiveTab("customer")}
          >
            Delivered
          </div>
          <div
            className={`tab ${activeTab === "order" ? "active" : ""}`}
            onClick={() => setActiveTab("order")}
          >
            Cancelled Orders
          </div>
        </div> */}

        {orderData?.length > 0 ? (
          orderData.map((item:any, index:number) => (
            <div key={index}>
              <div className="heading">
                <img src={wheelBoy} alt="store" />
                <h3>{item?.sellerDetails?.storeName}</h3>
              </div>

              {item.items?.map((productItem:any, idx:number) => {
                const orderPayload = {
                  id: item?._id,
                  buypassId: item?.buypassId,
                  name: productItem?.productName,
                  description: productItem?.description,
                  url: productItem?.productImage,
                  sellerId: item?.sellerDetails?.id,
                  sellerName: item?.sellerDetails?.storeName,
                  price: productItem?.price,
                  createdOn: item?.createdOn,
                };

                return (
                  <div
                    className="cardDv"
                    key={idx}
                    onClick={() => handleSendOrder(orderPayload)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="contentDv">
                      <figure>
                        <img src={productItem?.productImage} className="proDuct" alt="product" />
                      </figure>
                      <div className="dataDv">
                        <p>{productItem?.category}</p>
                        <h3>{productItem?.productName}</h3>
                        <h2>Rs. {productItem?.price}</h2>
                        <div className="discountdv">
                          <h5>Rs. {item.orderSummary.discount}</h5>
                        </div>
                      </div>
                    </div>
                    <div className="qtyDv">
                      <div className="paidDv">{item.status}</div>
                      <h4>QTY: {productItem?.ordignalQuantity}</h4>
                    </div>
                  </div>
                );
              })}
            </div>
          ))
        ) : (
          <p className="no-orders">No orders found.</p>
        )}
      </ModalBody>
    </Modal>
  );
};

ChatModal.propTypes = {
  onCloseClick: PropTypes.func,
  handleSendOrder: PropTypes.func,
  show: PropTypes.any,
  orderData: PropTypes.any,
};

export default ChatModal;
